module.exports = {"password":"Password","placeholder":"Set password","show":"Show","hide":"Hide","character":"{{ count }}+ characters","digit":"1+ number","letter":"1+ letter","lowercase_letter":"1+ lowercase","uppercase_letter":"1+ uppercase","special":"1+ special symbol","optional":"optional","warning_email":"Password should not include your email","password_hint":"","please_include":"Must include:","minimum_length":"Minimum {{count}} characters","make_it_strong":"Make it stronger!"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/passwordAnimated.json
// module id = 543
// module chunks = 245 964